'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  margin: 0px 3px;\n  background: ', ';\n  color: ', ';\n  border-radius: 2px;\n  padding: 3px;\n  pointer-events: auto;\n  cursor: pointer;\n  user-select: none;\n'], ['\n  margin: 0px 3px;\n  background: ', ';\n  color: ', ';\n  border-radius: 2px;\n  padding: 3px;\n  pointer-events: auto;\n  cursor: pointer;\n  user-select: none;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: inline-block;\n  margin-right: ', 'px;\n  font-weight: 700;\n  font-size: 8px;\n  text-transform: uppercase;\n'], ['\n  display: inline-block;\n  margin-right: ', 'px;\n  font-weight: 700;\n  font-size: 8px;\n  text-transform: uppercase;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('../../../../libs/colors');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Colors


var Container = _styledComponents2.default.div(_templateObject, function (_ref) {
  var selected = _ref.selected;
  return selected ? _colors.red : _colors.grey;
}, function (_ref2) {
  var selected = _ref2.selected;
  return selected ? _colors.white : _colors.darkGrey;
});

var Label = _styledComponents2.default.span(_templateObject2, function (_ref3) {
  var margin = _ref3.margin;
  return margin ? 5 : 0;
});

var Tag = function Tag(_ref4) {
  var tag = _ref4.tag,
      shortTag = _ref4.shortTag,
      children = _ref4.children,
      selected = _ref4.selected,
      onClick = _ref4.onClick;
  return _react2.default.createElement(Container, {
    selected: selected,
    onClick: onClick
  }, !children ? _react2.default.createElement(Label, null, tag) : _react2.default.createElement(Label, {
    margin: true
  }, shortTag || tag), children);
};

Tag.propTypes = {
  tag: _propTypes2.default.string.isRequired,
  shortTag: _propTypes2.default.string,
  children: _propTypes2.default.node,
  selected: _propTypes2.default.bool,
  onClick: _propTypes2.default.func
};
Tag.defaultProps = {
  onClick: function onClick() {
    return null;
  }
};
exports.default = Tag;